import API from 'services/API';
import { FLIGHT_STATUS_NAMES } from 'utils/const';

export const get = () => API.get('/FlightStatus');

export const getById = id => API.get(`/FlightStatus/${id}`);

/**
 * Id du statut portant le nom donné dans la course courante.
 * Les statuts sont scopés par course : leurs ids changent d'une course à l'autre
 * (1-4 pour la course 1, 29-32 pour la course 8, etc.).
 */
export const getIdByName = name =>
  get().then(res => {
    const statuses = res.data || [];
    const found = statuses.find(
      status => (status.name || '').toLowerCase() === String(name).toLowerCase(),
    );
    return found ? found.id : undefined;
  });

/** Id du statut correspondant au rôle métier (PREVIEW, VALIDATED, CANCELLED, ARCHIVED). */
export const getIdByRole = role => getIdByName(FLIGHT_STATUS_NAMES[role]);
